import React from "react";

import { GenericExternalLink } from "@components/generic-external-link";
import { NorthbeamUtmPlatform } from "@features/utm-guide";

import { CopyUtmParams } from "../copy-utm-params";

export const Partnerize = () => (
  <div className="flex flex-col gap-3">
    <p className="mb-0">
      To automatically have parameters added to creative links in the program,
      click on the <b>Generic Link</b> in the creative drop down menu of the
      program interface.
    </p>
    <p className="mb-0">
      Add the text below to the <b>Destination URL Parameters</b> box then click{" "}
      <b>save</b>.
    </p>
    <p className="mb-0">
      For more information, please check out <b>Partnerize</b> official{" "}
      <GenericExternalLink href="https://support.ascendpartner.com/s/article/Destination-URL-Parameters">
        documentation.
      </GenericExternalLink>
    </p>
    <CopyUtmParams
      className="mt-3"
      platform={NorthbeamUtmPlatform.PARTNERIZE}
      hideQuestionMark
    />
  </div>
);
